import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Options } from '@angular-slider/ngx-slider';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobService } from 'src/app/core/services/job.service';
import { SettingService } from 'src/app/core/services/setting.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UibModalService } from 'src/app/core/services/uibModalService';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { UserService } from 'src/app/core/services/user.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { SettingsActionsModalComponent } from './settings-actions-modal/settings-actions-modal.component';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
    selector: 'app-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['./settings-page.component.css'],
    preserveWhitespaces: true
})
export class SettingsPageComponent implements OnInit, OnDestroy {
    @Input() $transition$: any;

    MESSAGECONSTANTS: any = MESSAGECONSTANTS;

    stateParams: any;
    accessMode: any;
    viewOnlyMode = false;

    currentCompany: any;
    form: any = {
        settingsTypeform: {},
        performanceSetting: {}
    };
    globalSettings: any = null;
    settings: any = {
        licensePreferenceSetting: {},
        performanceSetting: {}
    };
    savedSettings: any = {};
    allClientsOrBus: any[] = [];
    copyChecked = false;
    copyClientCheckBox = false;
    availableClientsToCopy: any[] = [];
    clientCopy: any = null;
    selectedClientOrBu: any = { id: null };
    isCustomSettingsSelected = false;
    isClientGlobalCopy = true;
    hasAccessToCompanySettings = false;
    isCompanySelected = true;
    isInHost = false;
    isVendorCompany = false;
    globalSettingsCompanyModel = false;
    globalSettingsClientModel = false;
    isUsersPanelOpen = false;
    isRequisitionPanelOpen = false;
    licensePreferencePanelFlags: any[] = [];
    scoreSliderOptions: Options[] = [];
    timeToCompleteSliderOptions: Options[] = [];
    scoreSliderDragging: boolean[] = [];
    timeToCompleteSliderDragging: boolean[] = [];
    performanceSliderOptions: Options[] = [];
    performanceSliderDragging: boolean[] = [];
    toggleClientValue: any = {};
    toggleClientValueCopy: any = {};
    companySelectionActive = true;
    isClientCopyObject = false;
    clientCopyMandatoryMessage = false;
    isStillProcessing = true;
    isStillProcessingModified = true;
    loadingFlag = true;
    userRole: string;
    isStaffingCompany = false;
    isCorporateCompany = false;
    selectedClient: any = null;
    isOutreachPanelOpen = false;
    isSuperUserOrAdmin = false;

    client: any = null;
    isClientExists = false;
    selectedClientNameForMessage: any;
    selectedBUNameForMessage: any;
    selectedClientNameForMessageCopy: any;
    selectedBUNameForMessageCopy: any;
    settingsClient: any;
    settingsCopyForCompany: any;
    settingsCopy: any;
    isClientGlobal = false;
    showClientsOrBusList = false;
    activityMap: any[] = [];
    clientsOrBUsList: any[] = [];
    settingsActionsModal: BsModalRef;

    private beforeUnloadListener = () => {
        if(angular.equals(this.$state.$current.name, 'missioncontrol.settings')) {
            this.storageService.remove('removeSliderId');
        }
    };

    constructor(
        public $state: StateService,
        private settingService: SettingService,
        private userService: UserService,
        private companyService: CompanyService,
        private jobService: JobService,
        private utilityService: UtilityService,
        private userRoleService: UserRoleService,
        private uibModalService: UibModalService,
        private alertsAndNotificationsService: AlertAndNotificationsService,
        private storageService: StorageService,
        private bsModalService: BsModalService,
        private authService:AuthService
    ) { }

    ngOnInit() {
        this.stateParams = this.$transition$.params();
        this.accessMode = this.stateParams.accessMode;
        this._initializeVariables();
        this.isVendorCompany = this.companyService.isCompanyVendor();
        this.viewOnlyMode = this.accessMode !== null;
        window.addEventListener('beforeunload', this.beforeUnloadListener);
        this._getSettings();
        this._getAllActivityTypes();
    }

    ngOnDestroy() {
        window.removeEventListener('beforeunload', this.beforeUnloadListener);
    }

    _initializeVariables() {
        this.currentCompany = this.authService.getUserDetails().company;
        this.isInHost = this.utilityService.isInHost();
        this.userRole = this.authService.getUserDetails().roleScreenRef.role.name;
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.isCorporateCompany = this.companyService.isCorporateCompany();
        this.isSuperUserOrAdmin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
    }

    _getSettings() {
        if(this.isInHost) {
            this.hasAccessToCompanySettings = true;
            this._getFourDotFiveSettings();
        } else {
            if((this.userRole === 'StaffingRecruitingManager' && !this.isVendorCompany) ||
                this.userRole === this.MESSAGECONSTANTS.ROLESNAMES.HIRING_MANAGER ||
                this.userRole === 'CorporateRecruitingManager') {
                this._getClientsOrBus(() => {
                    this._getLoggedInUserDetails(() => {
                        if(this.hasAccessToCompanySettings) {
                            this._getSettingsForStaffingOrCorporateCompany();
                        } else {
                            this.manageClientOrBuSelection();
                        }
                    });
                });
            } else {
                this.hasAccessToCompanySettings = true;
                this._getSettingsForStaffingOrCorporateCompany();
            }
        }
    }

    _getFourDotFiveSettings() {
        this.settingService.getFourDotFiveSettings((data) => {
            this.settings = data;
            this._setReminderSettings();
            if(this.isInHost) {
                this.settingsCopyForCompany = angular.copy(data);
            }
            this.settingsCopy = data;
            this.globalSettings = angular.copy(this.settings);
            this.savedSettings = angular.copy(this.settings);
            this.isStillProcessing = false;
            this.loadingFlag = false;
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessing = false;
        });
    }

    _setReminderSettings() {
        this.scoreSliderOptions = [];
        this.timeToCompleteSliderOptions = [];
        this.scoreSliderDragging = [];
        this.timeToCompleteSliderDragging = [];
        angular.forEach(this.settings.licensePreferenceSetting, (setting, index) => {
            if(setting.reminderInterval > 0) {
                setting.defaultReminderInterval = setting.reminderInterval;
                setting.isReminderEnabled = true;
            } else {
                setting.defaultReminderInterval = 2;
                setting.isReminderEnabled = false;
            }
            this.scoreSliderOptions[index] = this._buildScoreSliderOptions(setting);
            this.timeToCompleteSliderOptions[index] = this._buildTimeToCompleteSliderOptions(setting);
            this.scoreSliderDragging[index] = false;
            this.timeToCompleteSliderDragging[index] = false;
        });

        this.performanceSliderOptions = [];
        this.performanceSliderDragging = [];
        angular.forEach(this.settings.performanceSetting, (setting, index) => {
            this.performanceSliderOptions[index] = this._buildPerformanceSliderOptions(setting);
            this.performanceSliderDragging[index] = false;
        });
    }

    // The backend's notifyOn is a LinkedHashMap<NotifyEnum, Notify> (e.g. {"CANDIDATE_CARD": {...}}),
    // which Jackson serializes as a JSON object keyed by enum name, not a real array. AngularJS's
    // ng-repeat tolerated iterating that object directly; Angular's *ngFor throws
    // NG_UNSUPPORTED_ITERABLE on it and drops the whole block from the view. This is a read-only
    // view helper for the template's *ngFor - it must not mutate notifyOn in place, since the same
    // object is what gets sent back verbatim in the save payload. The array it returns shares its
    // card objects (not clones) with the original, so `[(ngModel)]="cards.enabled"` still writes
    // through to the object that gets saved.
    getNotifyOnArray(notifyOn: any): any[] {
        if (!notifyOn) {
            return [];
        }
        if (Array.isArray(notifyOn)) {
            return notifyOn;
        }
        return Object.keys(notifyOn).map((key) => notifyOn[key]);
    }

    _buildScoreSliderOptions(setting: any): Options {
        return {
            floor: 0,
            ceil: 100,
            step: 0.5,
            disabled: !this.isSectionActive() || !setting.isEnabled,
            hideLimitLabels: true,
            hidePointerLabels: true,
            showSelectionBar: true
        };
    }

    _buildTimeToCompleteSliderOptions(setting: any): Options {
        return {
            floor: 0,
            ceil: 10,
            step: 1,
            disabled: !this.isSectionActive() || !setting.isEnabled,
            hideLimitLabels: true,
            hidePointerLabels: true,
            showSelectionBar: true
        };
    }

    _buildPerformanceSliderOptions(setting: any): Options {
        return {
            floor: 0,
            ceil: Number(setting.maxLimit),
            step: 1,
            disabled: !this.isSectionActive(),
            hideLimitLabels: true,
            hidePointerLabels: true,
            showOuterSelectionBars: true
        };
    }

    getSliderLabelPosition(value: number, floor: number, ceil: number): number {
        const range = ceil - floor;
        const percent = range > 0 ? ((value - floor) / range) * 100 : 0;
        return Math.min(Math.max(percent, 5), 85);
    }

    onPerformanceSliderChangeStart(index: number) {
        this.performanceSliderDragging[index] = true;
    }

    onPerformanceSliderChangeEnd(index: number) {
        this.performanceSliderDragging[index] = false;
    }

    toggleEditOptionForSliders(rangeSliderIndex: number) {
        this.settings.performanceSetting[rangeSliderIndex].duplicateMaxLImit = this.settings.performanceSetting[rangeSliderIndex].maxLimit;
        this.settings.performanceSetting[rangeSliderIndex].isSelected = true;
    }

    cancelTimeForSliders(rangeSlider: number) {
        this.settings.performanceSetting[rangeSlider].isSelected = false;
        this.settings.performanceSetting[rangeSlider].isError = false;
        this.settings.performanceSetting[rangeSlider].isErrorForMax = false;
        this.settings.performanceSetting[rangeSlider].duplicateMaxLImit = this.settings.performanceSetting[rangeSlider].maxLimit;
    }

    updateMaxLimitForSliders(rangeSlider: number, maxLimit: any) {
        const performanceSetting = this.settings.performanceSetting[rangeSlider];
        const newMaxLimit = Number(maxLimit);
        if(newMaxLimit >= performanceSetting.maxValue && newMaxLimit <= 200 && performanceSetting.maxValue !== 0) {
            performanceSetting.isSelected = false;
            performanceSetting.maxLimit = newMaxLimit;
            const sliderIdInUI = this.settings.performanceSetting.length + rangeSlider + 3;
            this.storageService.set('removeSliderId', sliderIdInUI, null);
            this.performanceSliderOptions[rangeSlider] = this._buildPerformanceSliderOptions(performanceSetting);
            performanceSetting.isError = false;
            performanceSetting.isErrorForMax = false;
        } else {
            if(newMaxLimit > 200) {
                performanceSetting.isErrorForMax = true;
                performanceSetting.isError = false;
            } else {
                performanceSetting.isError = true;
                performanceSetting.isErrorForMax = false;
            }
        }
    }

    onScoreSliderChangeStart(index: number) {
        this.scoreSliderDragging[index] = true;
    }

    onScoreSliderChangeEnd(index: number) {
        this.scoreSliderDragging[index] = false;
    }

    onTimeToCompleteSliderChangeStart(index: number) {
        this.timeToCompleteSliderDragging[index] = true;
    }

    onTimeToCompleteSliderChangeEnd(index: number) {
        this.timeToCompleteSliderDragging[index] = false;
    }

    _getClientsOrBus(callback) {
        this.isStillProcessing = true;
        this.userService.getUsersOnlyClientsOrBus(this.currentCompany.companyId, (data) => {
            this.isClientExists = data && data.length > 0;
            this.allClientsOrBus = angular.copy(data);
            angular.forEach(this.allClientsOrBus, (clientOrBu) => {
                if(clientOrBu.companyType === 'Corporation') {
                    clientOrBu.aliasName = clientOrBu.aliasName + ' &#xf1e0;';
                }
            });
            if(this.allClientsOrBus.length > 0) {
                this.client = this.allClientsOrBus[0];
                this.selectedClientOrBu.id = this.client.companyId;
                this.getSettingsForClient(this.client);
            } else {
                this.isStillProcessing = false;
                this.loadingFlag = false;
            }
            if(callback) {
                callback();
            }
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessing = false;
        });
    }

    getSettingsForClient(client) {
        this.isStillProcessing = true;
        this.loadingFlag = true;
        this.toggleClientValue = client;
        if(client.companyType === 'Client' || client.companyType === 'Corporation') {
            this.selectedClientNameForMessage = client.companyName;
        } else if(client.companyType === 'BusinessUnit') {
            this.selectedBUNameForMessage = client.companyName;
        }
        this.globalSettingsClientModel = false;

        this.client = client;
        if(this.availableClientsToCopy.length !== 0) {
            this.availableClientsToCopy = [];
            this.allClientsOrBus.forEach((element) => {
                if(element.companyId !== client.companyId) {
                    this.availableClientsToCopy.push(element);
                }
            });
        }
        this.settingService.getClientOrBuSettings(this.currentCompany.companyId, client.companyId, (data) => {
            this.settings = data;
            this._setReminderSettings();
            this.isClientGlobal = data.global;
            this.isClientGlobalCopy = this.isClientGlobal;
            this.settingsClient = angular.copy(this.settings);
            this.savedSettings = angular.copy(this.settings);
            this.copyChecked = false;
            this.isClientCopyObject = false;
            this.clientCopyMandatoryMessage = false;
            this.isStillProcessing = false;
            if(!this.viewOnlyMode) {
                this._getClientsOrBusHavingCustomSettings();
            } else {
                this.loadingFlag = false;
            }
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessing = false;
        });
    }

    _getLoggedInUserDetails(callback) {
        this.userService.getLoggedInUserDetails((data) => {
            if(!data.isBUsOrClientsAvailable) {
                this.hasAccessToCompanySettings = true;
                if(callback) {
                    callback();
                }
            }
            if(!this.hasAccessToCompanySettings) {
                this._isUserEntityScopeAll(() => {
                    if(callback) {
                        callback();
                    }
                });
            }
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessing = false;
        });
    }

    _isUserEntityScopeAll(callback) {
        this.hasAccessToCompanySettings = true;
        if(callback) {
            callback();
        }
    }

    _getSettingsForStaffingOrCorporateCompany() {
        this.loadingFlag = true;
        this.isStillProcessingModified = true;

        this.settingService.getCorporateOrStaffingCompanySettings(this.currentCompany.companyId, (data) => {
            this._massageCompanySettings(data);
            this.loadingFlag = false;
            this.isStillProcessingModified = false;
            if(!this.isInHost) {
                this.changeCompanySettings();
            }
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessingModified = false;
        });
    }

    _massageCompanySettings(settings) {
        this.settings = settings;
        this._setReminderSettings();
        this.settingsCopyForCompany = angular.copy(settings);
        for(let i = 0; i < this.settings.performanceSetting.length; i++) {
            this.settings.performanceSetting[i].duplicateMaxLImit = this.settings.performanceSetting[i].maxLimit;
            this.settings.performanceSetting[i].isSelected = false;
            this.settings.performanceSetting[i].isError = false;
        }
        this.savedSettings = angular.copy(this.settings);
    }

    manageClientOrBuSelection() {
        this.isCompanySelected = false;
        this.loadingFlag = true;
        this.isStillProcessing = !this.globalSettingsClientModel;
        this.companySelectionActive = false;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.showClientsOrBusList = true;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.copyChecked = false;

        if(this.allClientsOrBus.length === 0) {
            this._getClientsOrBus(() => {
                if(this.allClientsOrBus.length > 0) {
                    if(this.toggleClientValue && this.toggleClientValue.company) {
                        if(this.toggleClientValue.company.companyType === 'Client') {
                            this.selectedClientNameForMessage = this.toggleClientValue.company.name;
                        } else if(this.toggleClientValue.company.companyType === 'BusinessUnit') {
                            this.selectedBUNameForMessage = this.toggleClientValue.company.name;
                        }
                        if(this.showClientsOrBusList && this.client != null && this.copyChecked && this.toggleClientValueCopy.company) {
                            if(this.toggleClientValueCopy.company.companyType === 'Client') {
                                this.selectedClientNameForMessageCopy = this.toggleClientValueCopy.company.name;
                            } else if(this.toggleClientValueCopy.company.companyType === 'BusinessUnit') {
                                this.selectedBUNameForMessageCopy = this.toggleClientValueCopy.company.name;
                            }
                        }
                    }
                } else {
                    this.loadingFlag = false;
                }
            });
        } else {
            this.getSettingsForClient(this.client);
        }
    }

    changeCompanySettings() {
        this.settings = angular.copy(this.settingsCopyForCompany);
        this.savedSettings = angular.copy(this.settingsCopyForCompany);
        this._setReminderSettings();
        this.isStillProcessing = false;
        this.globalSettingsCompanyModel = false;
        this.isCustomSettingsSelected = true;
    }

    _getParentSettings() {
        this.settingService.getParentCompanySettings(this.currentCompany.companyId, (data) => {
            this.isStillProcessing = true;
            this.settings = data;
            this._setReminderSettings();
            for(let i = 0; i < this.settings.performanceSetting.length; i++) {
                this.settings.performanceSetting[i].duplicateMaxLImit = this.settings.performanceSetting[i].maxLimit;
                this.settings.performanceSetting[i].isSelected = false;
                this.settings.performanceSetting[i].isError = false;
            }
            this.savedSettings = angular.copy(this.settings);
            this.isStillProcessing = false;
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessing = false;
        });
    }

    _getClientsOrBusHavingCustomSettings() {
        this.isStillProcessing = true;
        this.loadingFlag = true;
        this.companyService.getClientsOrBusHavingCustomSettings(this.currentCompany.companyId, (data) => {
            if(data.length === 0) {
                this.copyClientCheckBox = false;
            }
            this.availableClientsToCopy = [];
            data.forEach((element) => {
                if(element.company.id !== this.client.companyId) {
                    this.availableClientsToCopy.push(element);
                    this.copyClientCheckBox = true;
                }
            });
            if(this.availableClientsToCopy.length < 1) {
                this.copyClientCheckBox = false;
            }
            this.isStillProcessing = false;
            this.loadingFlag = false;
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessing = false;
        });
    }

    _changeClientName() {
        this.userService.getUsersOnlyClientsOrBus(this.currentCompany.companyId, (data) => {
            this.clientsOrBUsList = data;
            for(let i = 0; i < this.clientsOrBUsList.length; i++) {
                for(let k = 0; k < this.allClientsOrBus.length; k++) {
                    if(this.allClientsOrBus[k].companyId === this.clientsOrBUsList[i].companyId) {
                        this.allClientsOrBus[k].aliasName = this.clientsOrBUsList[i].aliasName;
                        if(this.allClientsOrBus[k].companyId === this.client.companyId) {
                            this.client.aliasName = this.allClientsOrBus[k].aliasName;
                        }
                    }
                }
            }
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    _getAllActivityTypes() {
        this.jobService.getActivityTypes((data) => {
            this.activityMap = [];
            angular.forEach(data, (val) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    redirectToUrl(url: string, isReloadRequired: boolean) {
        this.$state.go(url, null, { reload: isReloadRequired });
    }

    manageCompanySelection() {
        this.isCompanySelected = true;
        this.companySelectionActive = true;
        this.globalSettingsCompanyModel = false;
        this.globalSettingsClientModel = false;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.allClientsOrBus = [];
        this.isClientGlobalCopy = true;
        this.client = null;
        this.copyClientCheckBox = false;
        this.copyChecked = false;
        this.toggleClientValue = {};
        this.showClientsOrBusList = false;
        if(!this.settingsCopyForCompany) {
            this._getSettingsForStaffingOrCorporateCompany();
        } else {
            this.settings = angular.copy(this.settingsCopyForCompany);
            this._setReminderSettings();
        }
    }

    onClientOrBuChange() {
        const selectedClientOrBu = this.allClientsOrBus.find((clientOrBu) => clientOrBu.companyId === this.selectedClientOrBu.id);
        this._getClientSettings(selectedClientOrBu);
        if(!this.viewOnlyMode) {
            this.copyChecked = false;
        }
    }

    _getClientSettings(selectedClient) {
        if(selectedClient === undefined) {
            return;
        }
        this.getSettingsForClient(selectedClient);
    }

    getSettingsForClientToCopy(clientCopy) {
        if(!clientCopy) {
            return;
        }
        this.isStillProcessing = true;
        this.toggleClientValueCopy = clientCopy;
        this.isClientCopyObject = true;
        this.clientCopyMandatoryMessage = false;
        if(clientCopy.company.companyType === 'Client' || clientCopy.company.companyType === 'Corporation') {
            this.selectedClientNameForMessageCopy = clientCopy.company.name;
        } else if(clientCopy.company.companyType === 'BusinessUnit') {
            this.selectedBUNameForMessageCopy = clientCopy.company.name;
        }
        this.clientCopy = clientCopy;
        this.loadingFlag = true;
        this.settingService.getClientOrBuSettings(this.currentCompany.companyId, clientCopy.company.id, (data) => {
            this.settings = data;
            this._setReminderSettings();
            this.savedSettings = data;
            this.loadingFlag = false;
        }, (error) => {
            if(this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.loadingFlag = false;
            this.isStillProcessing = false;
        });
    }

    isCopyChecked() {
        this.globalSettingsClientModel = false;
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.availableClientsToCopy = [];
        this.clientCopy = null;
        if(this.copyChecked) {
            this._getClientsOrBusHavingCustomSettings();
        } else {
            this.settings = angular.copy(this.settingsClient);
            this.savedSettings = angular.copy(this.settingsClient);
            this._setReminderSettings();
        }
    }

    isModifyClientSelected() {
        return !this.isInHost && !this.companySelectionActive;
    }

    isSectionActive() {
        if(this.isInHost) {
            return true;
        }
        return !(this.globalSettingsClientModel || this.globalSettingsCompanyModel || this.viewOnlyMode);
    }

    reminderEnabledOrDisabled(settingIndex: number) {
        const reminderSetting = angular.copy(this.settings.licensePreferenceSetting[settingIndex]);
        if(reminderSetting.isReminderEnabled) {
            reminderSetting.reminderInterval = reminderSetting.defaultReminderInterval;
        } else {
            reminderSetting.reminderInterval = 0;
        }
        this.settings.licensePreferenceSetting[settingIndex] = angular.copy(reminderSetting);
    }

    onMetricsValueChange(metricsEnum: string, changedTo: any, metricIndex: number, metricStepIndex: number) {
        const minValue = 0;
        let maxValue = 100;
        if(metricsEnum === 'TIME_IN_WORKFLOW_STEP') {
            maxValue = 50;
        }
        if(changedTo === undefined) {
            changedTo = 0;
        } else if(changedTo > maxValue) {
            changedTo = maxValue;
        } else if(changedTo < minValue) {
            changedTo = minValue;
        }
        this.settings.metricsForWorkflowSteps[metricIndex].steps[metricStepIndex].value = changedTo;
    }

    isOutReachSettingEditable(): boolean {
        return this.settings.outReachSetting && ((this.isInHost && this.settings.outReachSetting.enabled) ||
            (!this.isInHost && this.settings.outReachSetting.enabled && this.settings.hostOrParentEnabled));
    }

    viewActivities() {
        let companyId = null;
        let context = 'companySettings';
        let isSharedClient = false;
        if(this.isCompanySelected) {
            companyId = this.currentCompany.companyId;
        } else if(this.selectedClientOrBu.id !== null) {
            companyId = this.selectedClientOrBu.id;
            context = 'clientOrBuSettings';
            isSharedClient = this.client.companyType === 'Corporation';
        }
        const config = new ModalConfig();
        const modalData: any = {
            title: 'Setting Activities',
            activityMap: this.activityMap,
            companyId,
            isSharedClient,
            context
        };
        config.class = 'custom-modal-xl custom-ngx-modal';
        config.initialState = modalData;
        this.settingsActionsModal = this.bsModalService.show(SettingsActionsModalComponent, config);
    }

    setSettings() {
        if(this.companySelectionActive) {
            this._setSettingsForCompany();
        } else {
            this._setSettingsForClientOrBU();
        }
    }

    _setSettingsForCompany() {
        this._changeCompanySettingsBeforeSave();
        if(!this.settingsCopyForCompany.global && angular.equals(this.savedSettings, this.settingsCopyForCompany)) {
            this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
        } else if(!this.isInHost && this.globalSettingsCompanyModel) {
            this.settingService.deleteStaffingOrCorpSettings(this.currentCompany.companyId, () => {
                this.globalSettingsCompanyModel = false;
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.SETTINGS_FOR_COMPANY +
                    " '<b><i class='wrap-word'>" + this.authService.getUserDetails().company.companyName + "</i></b>' " +
                    this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.UPDATE_SUCCESS, 'success');
                this.settingService.getCorporateOrStaffingCompanySettings(this.currentCompany.companyId, (data) => {
                    this._massageCompanySettings(data);
                }, (error) => {
                    if(this.authService.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    this.$state.go('missioncontrol.dashboard', null, { reload: true });
                });
            }, (error) => {
                if(this.authService.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                this.cancel();
            });
        } else if(this.settingsCopyForCompany.global || !angular.equals(this.savedSettings, this.settingsCopyForCompany)) {
            this.settingService.setCompanySettings(this.currentCompany.companyId, this.savedSettings, (response) => {
                this.settingService.getCorporateOrStaffingCompanySettings(this.currentCompany.companyId, (data) => {
                    this.settings = data;
                    this._setReminderSettings();
                    this.settingsCopyForCompany = angular.copy(this.settings);
                    this.savedSettings = angular.copy(this.settings);
                    if(this.isInHost) {
                        this.settingsCopy = data;
                        this.globalSettings = angular.copy(this.settings);
                    }
                    this.alertsAndNotificationsService.showBannerMessage(response.message, 'success');
                }, (error) => {
                    if(this.authService.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }, (error) => {
                if(this.authService.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                this.cancel();
            });
        }
    }

    _changeCompanySettingsBeforeSave() {
        this.savedSettings = angular.copy(this.settings);
        for(let i = 0; i < this.settings.performanceSetting.length; i++) {
            delete this.settings.performanceSetting[i].duplicateMaxLImit;
            delete this.settings.performanceSetting[i].isSelected;
            delete this.settings.performanceSetting[i].isError;
            delete this.settings.performanceSetting[i].isErrorForMax;

            delete this.savedSettings.performanceSetting[i].duplicateMaxLImit;
            delete this.savedSettings.performanceSetting[i].isSelected;
            delete this.savedSettings.performanceSetting[i].isError;
            delete this.savedSettings.performanceSetting[i].isErrorForMax;
        }
    }

    _setSettingsForClientOrBU() {
        if(!(this.client !== null && this.copyChecked && this.clientCopy === null)) {
            this._changeClientSettingsBeforeSave();
            this.clientCopyMandatoryMessage = false;
            if(!this.settingsClient.global && angular.equals(this.savedSettings, this.settingsClient)) {
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
            } else if(this.globalSettingsClientModel) {
                const clientDetails = {
                    isClientCompanySettingsActivity: this.client.companyType === 'Corporation'
                };
                this.settingService.deleteClientOrBuSettings(this.currentCompany.companyId, this.client.companyId, clientDetails, () => {
                    this.globalSettingsClientModel = false;
                    this._changeClientName();
                    this.getSettingsForClient(this.client);
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.SETTINGS_FOR + '' + this.client.companyType +
                        " '<b><i class='wrap-word'>" + this.client.companyName + "</i></b>' " +
                        this.MESSAGECONSTANTS.NOTIFICATIONS.SETTINGS.UPDATE_SUCCESS, 'success');
                }, (error) => {
                    if(this.authService.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    this.cancel();
                });
            } else if(this.settingsClient.global || !angular.equals(this.savedSettings, this.settingsClient)) {
                this.settingService.setClientOrBuSettings(this.currentCompany.companyId, this.client.companyId, this.savedSettings, (data) => {
                    this.copyChecked = false;
                    this.settings = data;
                    this._setReminderSettings();
                    this.isClientGlobal = data.global;
                    this.isClientGlobalCopy = this.isClientGlobal;
                    this.settingsClient = angular.copy(this.settings);
                    this.savedSettings = angular.copy(this.settings);
                    this.isClientCopyObject = false;
                    this.clientCopyMandatoryMessage = false;
                    this._changeClientName();
                    this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                }, (error) => {
                    if(this.authService.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    this.cancel();
                });
            }
        } else {
            this._showCopyClientValidationAlert();
        }
    }

    _changeClientSettingsBeforeSave() {
        this.savedSettings = angular.copy(this.settings);
        for(let i = 0; i < this.settings.performanceSetting.length; i++) {
            delete this.settings.performanceSetting[i].duplicateMaxLImit;
            delete this.settings.performanceSetting[i].isSelected;
            delete this.settings.performanceSetting[i].isError;
            delete this.settings.performanceSetting[i].isErrorForMax;

            delete this.savedSettings.performanceSetting[i].duplicateMaxLImit;
            delete this.savedSettings.performanceSetting[i].isSelected;
            delete this.savedSettings.performanceSetting[i].isError;
            delete this.savedSettings.performanceSetting[i].isErrorForMax;
        }
    }

    _showCopyClientValidationAlert() {
        const copyMessage = this.isStaffingCompany ? 'Please select a Client to copy from.' : 'Please select a BU to copy from.';
        this.alertsAndNotificationsService.showAlert('Oh snap!', copyMessage, 'danger');
    }

    cancel() {
        if(this.companySelectionActive) {
            this.settings = angular.copy(this.settingsCopyForCompany);
            if(!this.isInHost) {
                this.globalSettingsCompanyModel = false;
                this.changeCompanySettings();
            }
        } else {
            this.settings = angular.copy(this.settingsClient);
            this.globalSettingsClientModel = false;
            this.copyChecked = false;
            this.changeClientSettings();
        }
    }

    changeClientSettings() {
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.settings = angular.copy(this.settingsClient);
        this.savedSettings = angular.copy(this.settingsClient);
        this._setReminderSettings();
        this.isStillProcessing = false;
        this.globalSettingsClientModel = false;
        this.copyChecked = false;
        this.isCustomSettingsSelected = true;
    }

    changeGlobalSettings() {
        this.isClientCopyObject = false;
        this.clientCopyMandatoryMessage = false;
        this.copyChecked = false;
        this.isCustomSettingsSelected = false;
        if(!this.companySelectionActive) {
            this.globalSettingsClientModel = true;
            this._getParentSettings();
        } else {
            this.globalSettingsCompanyModel = true;
            this._getFourDotFiveSettings();
        }
    }

    _isSettingsChanged(): boolean {
        if(this.companySelectionActive) {
            this._changeCompanySettingsBeforeSave();
            return !(angular.equals(this.savedSettings, this.settingsCopyForCompany) ||
                (!this.isInHost && this.globalSettingsCompanyModel && !angular.equals(this.savedSettings, this.settingsCopyForCompany)));
        } else {
            this._changeClientSettingsBeforeSave();
            if(this.allClientsOrBus.length > 0) {
                return !(angular.equals(this.savedSettings, this.settingsClient) ||
                    (this.globalSettingsClientModel && !angular.equals(this.savedSettings, this.settingsClient)));
            }
            return false;
        }
    }

    uiCanExit(transitions) {
        const toState = transitions.to().name;
        const toParams = transitions.params();
        if(this._isSettingsChanged() && toState !== 'login') {
            transitions.abort();
            const message = 'Unsaved data on the page will be lost. Do you still want to continue?';
            this.alertsAndNotificationsService.showConfirm('Warning!', message, 'warning', true, () => {
                this.cancel();
                this.storageService.remove('removeSliderId');
                this.storageService.set('outOfPage', 'movingOut', null);
                this.storageService.remove('wizardoperations');
                if(this.authService.isSwitchClicked) {
                    this.authService.setIsSwitchClicked(false);
                    this.uibModalService.showAllCompanies();
                } else {
                    this.$state.go(toState, toParams, { reload: true });
                }
            }, () => {
                if(this.authService.isSwitchClicked) {
                    this.authService.setIsSwitchClicked(false);
                }
            });
        } else if(this.authService.isSwitchClicked && !this._isSettingsChanged()) {
            transitions.abort();
            setTimeout(() => {
                this.uibModalService.showAllCompanies();
            }, 150);
            this.authService.setIsSwitchClicked(false);
        }
    }
}
